import BackButton from "@dashboard/components/BackButton";
import { ConfirmButton, ConfirmButtonTransitionState } from "@dashboard/components/ConfirmButton";
import Form from "@dashboard/components/Form";
import FormSpacer from "@dashboard/components/FormSpacer";
import { DashboardModal } from "@dashboard/components/Modal";
import useModalDialogErrors from "@dashboard/hooks/useModalDialogErrors";
import { buttonMessages } from "@dashboard/intl";
import { getFormErrors } from "@dashboard/utils/errors";
import { TextField } from "@material-ui/core";
import { Text } from "@saleor/macaw-ui-next";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

export interface FormData {
  trackingId: string;
}

export interface SampleRequestTrackingDialogProps {
  confirmButtonState: ConfirmButtonTransitionState;
  errors: Array<{ field?: string | null; message?: string | null }>;
  open: boolean;
  trackingId: string | null;
  onClose: () => void;
  onConfirm: (data: FormData) => void;
}

const SampleRequestTrackingDialog = ({
  confirmButtonState,
  errors: apiErrors,
  open,
  trackingId,
  onConfirm,
  onClose,
}: SampleRequestTrackingDialogProps) => {
  const intl = useIntl();
  const errors = useModalDialogErrors(apiErrors, open);
  const formFields = ["trackingId"];
  const formErrors = getFormErrors(formFields, errors);
  const initialData: FormData = {
    trackingId: trackingId || "",
  };

  return (
    <DashboardModal onChange={onClose} open={open}>
      <DashboardModal.Content size="xs">
        <Form initial={initialData} onSubmit={onConfirm}>
          {({ change, data, submit }) => (
            <DashboardModal.Grid>
              <DashboardModal.Header>
                <FormattedMessage
                  id="sampleRequestTrackingDialogTitle"
                  defaultMessage="Add Tracking ID"
                  description="dialog header"
                />
              </DashboardModal.Header>

              <TextField
                error={!!formErrors.trackingId}
                helperText={formErrors.trackingId?.message}
                label={intl.formatMessage({
                  id: "sampleRequestTrackingIdLabel",
                  defaultMessage: "Tracking ID",
                })}
                name="trackingId"
                onChange={change}
                value={data.trackingId}
                fullWidth
                data-test-id="tracking-id-input"
              />

              {errors.length > 0 && (
                <>
                  <FormSpacer />
                  {errors
                    .filter(err => err.field && !formFields.includes(err.field))
                    .map((err, index) => (
                      <Text display="block" color="critical1" key={index}>
                        {err.message || "An error occurred"}
                      </Text>
                    ))}
                </>
              )}

              <DashboardModal.Actions>
                <BackButton onClick={onClose} />
                <ConfirmButton
                  data-test-id="confirm-tracking-id-button"
                  transitionState={confirmButtonState}
                  onClick={submit}
                >
                  <FormattedMessage {...buttonMessages.save} />
                </ConfirmButton>
              </DashboardModal.Actions>
            </DashboardModal.Grid>
          )}
        </Form>
      </DashboardModal.Content>
    </DashboardModal>
  );
};

SampleRequestTrackingDialog.displayName = "SampleRequestTrackingDialog";
export default SampleRequestTrackingDialog;